// import React, { useEffect, useRef, useState } from "react";

// interface VisibleElement {
//   [key: string]: boolean;
// }

// const Mission: React.FC = () => {
//   const sectionRef = useRef<HTMLDivElement>(null);
//   const [visible, setVisible] = useState<VisibleElement>({});

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setVisible({ main: true });
//         }
//       },
//       { threshold: 0.3 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <div className="py-16 bg-white">
//       <section ref={sectionRef} className="relative w-full bg-white">
//         <div className="max-w-6xl mx-auto px-6">
//           <div className="text-center mb-16">
//             <div
//               className={`inline-block px-6 py-3 border border-gray-300 rounded-full text-gray-700 mb-8 transition-all duration-700 ${
//                 visible.main ? "animate-fade-in-up" : "opacity-0"
//               }`}
//             >
//               OUR MISSION
//             </div>

//             <h2
//               className={`text-6xl md:text-7xl font-light leading-tight mb-8 transition-all duration-700 ${
//                 visible.main ? "animate-fade-in-up" : "opacity-0"
//               }`}
//             >
//               Shaping a Sustainable Future
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
//             <div className="lg:col-span-2 space-y-6">
//               <p className="text-gray-600 text-lg leading-relaxed border-l-4 border-blue-500 pl-6">
//                 We believe sustainability isn't a choice—it's a responsibility.
//                 Founded by visionaries Devyansh Agrawal and Manisha, our journey
//                 began with one goal: to create impactful technologies that drive
//                 meaningful change.
//               </p>

//               <p className="text-gray-600 text-lg leading-relaxed">
//                 Today, we stand at the forefront of innovation, transforming the
//                 way the world approaches energy, materials, and infrastructure.
//                 Our work is rooted in deep research and powered by purpose.
//               </p>
//             </div>

//             <div className="lg:col-span-2 flex justify-center lg:justify-end">
//               <div className="relative w-full max-w-md">
//                 <div className="absolute inset-0 bg-gray-100 rounded-2xl transform rotate-3"></div>
//                 <img
//                   src="/mission.png"
//                   alt="Advanced Battery Technology"
//                   className="relative w-full h-60 lg:h-[300px] object-cover rounded-2xl shadow-lg"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Mission;

import React from "react";

const DevanantaHero: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-lime-600 via-lime-600 to-lime-600 text-white pt-28">
      <div className="container mx-auto px-6 lg:px-16 max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="lg:w-1/2 mb-12 lg:mb-0 lg:mr-12">
            <div className="max-w-lg">
              <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
                Sustainability
              </h1>
              <p className="text-xl lg:text-3xl text-slate-300 mb-8 leading-relaxed">
                Committed to environmentally friendly practices
              </p>
            </div>
          </div>

          <div className="lg:w-1/2 flex justify-center">
            <div className="relative w-full max-w-lg">
              <div className="rounded-2xl p-8">
                <div className="relative overflow-hidden rounded-lg">
                  <img
                    src="/sustain.png"
                    alt="Sustainability Illustration"
                    className="w-full h-[500px] object-cover"
                    style={{
                      maskImage:
                        "linear-gradient(to right, transparent 0%, black 15%, black 95%, transparent 100%), linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)",
                      WebkitMaskImage:
                        "linear-gradient(to right, transparent 0%, black 0%, black 95%, transparent 100%), linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)",
                      maskComposite: "intersect",
                      WebkitMaskComposite: "intersect",
                    }}
                  />
                  <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                      background:
                        "linear-gradient(to right, rgba(101, 163, 13, 1) 0%, transparent 10%, transparent 90%, rgba(101, 163, 13, 1) 100%), linear-gradient(to bottom, rgba(101, 163, 13, 1) 0%, transparent 5%, transparent 95%, rgba(101, 163, 13, 1) 100%)",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevanantaHero;